<template>
  <ul class="filter-item-wrap">
    <template v-if="!isEmpty">
      <li class="pureCheckBox" v-for="(item,index) in list" :key="index">
        <a-checkbox :value="item[key]" @change="(e) => updateChooseStatus(e, item)">{{ item[key] }}</a-checkbox>
        <span class="filter-value">{{ item.patent_num }}</span>
      </li>
      <li class="bottom-operation-wrap">
        <span v-if="isMore" @click="putAway">收起</span>
        <span v-if="nextPage" @click="loadMore">更多</span>
      </li>
    </template>
    <p style="textAlign:center" v-else>{{instance.noticText}}</p>
  </ul>
</template>

<script>

export default {
  props: {
    instance: Object // 结果参数
  },
  data() {
    return {
      list: [],
      isEmpty: true,
      nextPage: true,
      isMore: true // hits 是否大于当前 list 的长度
    }
  },
  watch: {
    instance: {
      handler(nVal) {
        if (!nVal) return
        this.initSetting(nVal) // 初始化默认配置
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 初始化设置参数
    initSetting(instance) {
      if (!instance) return
      const { key, currentIndex, list } = instance
      this.isEmpty = list.length === 0
      this.isMore = list.length >= 20
      Object.assign(this, { ...instance })
      this.key = key
      if (typeof key === 'object') {
        this.key = key[currentIndex]
      }
    },
    // 收起
    putAway() {
      this.$emit('putAway', { item: this.instance, status: false })
    },
    // 加载更多
    loadMore() {
      this.$emit('loadMore', this.instance)
    },
    // 更新当前选中的状态
    updateChooseStatus(e, instance) {
      const forbiddenMap = ['IpcGroup'] // 禁用保存的组件名单
      const isDisabled = forbiddenMap.includes(this.instance.componentGroup)
      if (isDisabled) return
      const { checked } = e.target
      if (!instance.checked) {
        return this.$set(instance, 'checked', checked)
      }
      instance.checked = checked
    }
  }
}
</script>
